import Typography from '@mui/material/Typography';
import { Link } from 'react-router';

export const PrivacyNotice = () => (
  <Typography variant="body1" sx={{ mt: 10 }}>
    Please visit our{' '}
    <Link
      to="https://www.openx.com/privacy-center/business-partner-privacy-policy/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Business Partner Privacy Policy
    </Link>{' '}
    to learn more about how OpenX and its vendors may process your personal data.
  </Typography>
);
